import { Service } from '@angular/core';
import type { Observable } from 'rxjs';
import type {
  OnyxAddressByType,
  OnyxAddressType,
} from '../components/address-input/enums';
import type { OnyxAddress } from '../components/address-input/interfaces';
import type { OnyxPaginated } from '../components/table/interfaces';

@Service()
export abstract class OnyxAddressService {
  public abstract geocode<T extends OnyxAddressType>(
    types: T[],
    query: string,
    limit: number,
  ): Observable<OnyxPaginated<OnyxAddressByType[T]>>;

  public abstract getRecentSearches<T extends OnyxAddressType>(
    types: T[],
    limit: number,
  ): Observable<OnyxAddressByType[T][]>;

  public abstract addToRecentSearches(_address: OnyxAddress): Observable<void>;
}
